import PropTypes from 'prop-types'
import {SectionGroupContainer, SectionGroupLabel} from '../ProjectSectionAccordion/ProjectSectionAccordianStyles'

/**
 * SectionGroupHeader 
 * Props:
 * @param {string} label - The category label text (e.g., "GEOGRAPHIES")
 * @param {string} id - Optional ID for accessibility linking
 * 

 */
const SectionGroupHeader = ({label, id}) => {
  return (
    <SectionGroupContainer>
      <SectionGroupLabel as='h3' id={id} data-testid={`section-group-${label.toLowerCase().replaceAll(/\s+/g, '-')}`}>
        {label}
      </SectionGroupLabel>
    </SectionGroupContainer>
  )
}

SectionGroupHeader.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string
}

export default SectionGroupHeader
